import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { PageHeader } from 'react-bootstrap'
import { push as pushPath } from 'react-router-redux'

import {
  OfferFilterRecord,
  SignupWithExternalsRecord,
} from 'internal-components/src/records'

import * as editActions from '../../redux/modules/signupEdit/actions'
import {
  selectErrorsByPath,
  selectEditSignupWithExternals,
} from '../../redux/modules/signupEdit/selectors'

import PageLoading from '../../components/Layout/PageLoading'
import MspSignup from '../../components/Signup/MspSignup'

export class NewSignupView extends React.Component {
  componentWillMount() {
    if (!this.props.signupWithExternals) {
      this.props.pushPath('/partner')
    }
    this.props.updateFilter('allowCalix', true);
  }

  render() {
    const {
      agreeTerms,
      emailChecking,
      emailRegistered,
      errors,
      filter,
      selectClient,
      selectOffer,
      selectUser,
      setAbn,
      setAddress,
      setAddressLocId,
      setChallengePhrase,
      setCompanyName,
      setCompanySize,
      setContact,
      setData,
      setDateOfBirth,
      setEmail,
      setEmailConfirm,
      setExtraOfferId,
      setFirstName,
      setLastName,
      setPreferredAppointmentDate,
      setPreferredAppointmentTime,
      setServicePassword,
      setSiteContactFirstName,
      setSiteContactLastName,
      setSiteContactNumber,
      setUserPassword,
      signupEditMeta,
      signupWithExternals,
      submitMsp,
      updateFilter,
      working,
    } = this.props

    if (!signupWithExternals) {
      return <PageLoading />
    }

    return (
      <section className="container">
        <PageHeader>Create New Signup for your Client</PageHeader>

        <MspSignup
          agreeTerms={agreeTerms}
          emailChecking={emailChecking}
          emailRegistered={emailRegistered}
          errors={errors}
          filter={filter}
          selectClient={selectClient}
          selectOffer={id => selectOffer(id, false)}
          selectUser={selectUser}
          setAbn={setAbn}
          setAddress={setAddress}
          setAddressLocId={setAddressLocId}
          setChallengePhrase={setChallengePhrase}
          setCompanyName={setCompanyName}
          setCompanySize={setCompanySize}
          setContact={setContact}
          setData={setData}
          setDateOfBirth={setDateOfBirth}
          setEmail={setEmail}
          setEmailConfirm={setEmailConfirm}
          setExtraOfferId={setExtraOfferId}
          setFirstName={setFirstName}
          setLastName={setLastName}
          setPreferredAppointmentDate={setPreferredAppointmentDate}
          setPreferredAppointmentTime={setPreferredAppointmentTime}
          setServicePassword={setServicePassword}
          setSiteContactFirstName={setSiteContactFirstName}
          setSiteContactLastName={setSiteContactLastName}
          setSiteContactNumber={setSiteContactNumber}
          setUserPassword={setUserPassword}
          signupEditMeta={signupEditMeta}
          signupWithExternals={signupWithExternals}
          submit={submitMsp}
          updateFilter={updateFilter}
          working={working}
        />
      </section>
    )
  }
}

NewSignupView.propTypes = {
  agreeTerms: Pt.func.isRequired,
  emailChecking: Pt.bool,
  emailRegistered: Pt.bool,
  errors: Ipt.map.isRequired,
  filter: Pt.instanceOf(OfferFilterRecord).isRequired,
  pushPath: Pt.func.isRequired,
  selectClient: Pt.func.isRequired,
  selectOffer: Pt.func.isRequired,
  selectUser: Pt.func.isRequired,
  setAbn: Pt.func.isRequired,
  setAddress: Pt.func.isRequired,
  setAddressLocId: Pt.func.isRequired,
  setChallengePhrase: Pt.func.isRequired,
  setCompanyName: Pt.func.isRequired,
  setCompanySize: Pt.func.isRequired,
  setContact: Pt.func.isRequired,
  setData: Pt.func.isRequired,
  setDateOfBirth: Pt.func.isRequired,
  setEmail: Pt.func.isRequired,
  setEmailConfirm: Pt.func.isRequired,
  setFirstName: Pt.func.isRequired,
  setLastName: Pt.func.isRequired,
  setServicePassword: Pt.func.isRequired,
  setSiteContactFirstName: Pt.func.isRequired,
  setSiteContactLastName: Pt.func.isRequired,
  setSiteContactNumber: Pt.func.isRequired,
  setUserPassword: Pt.func.isRequired,
  signupEditMeta: Ipt.map.isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord),
  submitMsp: Pt.func.isRequired,
  updateFilter: Pt.func.isRequired,
  working: Pt.bool.isRequired,
}

const mapStateToProps = state => ({
  emailChecking: state.signupEdit.getIn(['meta', 'emailChecking']),
  emailRegistered: state.signupEdit.getIn(['meta', 'emailRegistered']),
  errors: selectErrorsByPath(state.signupEdit),
  filter: state.signupEdit.getIn(['meta', 'filter']),
  signupEditMeta: state.signupEdit.get('meta'),
  signupWithExternals: selectEditSignupWithExternals(state, {
    sortBy: null,
  }),
  working: state.signupEdit.getIn(['meta', 'working']),
})

export default connect(
  mapStateToProps,
  {
    ...editActions,
    pushPath,
  },
)(NewSignupView)



// WEBPACK FOOTER //
// ./src/views/Msp/NewSignupView.jsx